
import { Button, Spinner } from "react-bootstrap"
import { useState, useEffect } from "react"
import { useSelector, useDispatch } from "react-redux"
import Select from "react-select"
import {
  getPatientGapldAction,
  createPatientGapldAction,
  updatePatientGapldAction,
  deletePatientGapldAction,
} from "../../../../../store/actions/PatientGapldAction"
import { sendGenderFormLinkAction } from "../../../../../store/actions/PatientLinkAction"
import { showErrorAlert } from "../../../../../services/ErrorHandlingService"
import { formatDate } from "../../../../../utils/dateUtils"
const PatientGapld = ({ patientId }) => {
  // Accept patientId as a prop
  const dispatch = useDispatch()
  const patientGapldEntries = useSelector((state) => state.patientGapld?.patientGapldEntries || [])
  const patientDetails = useSelector((state) => state.patients?.patientDetails)
  const prescriptionPatientDetails = useSelector((state) => state.prescriptionState?.patientDetails)
  const patient_id = patientId || prescriptionPatientDetails?.patient_id || patientDetails?.patient_id
  const [submitting, setSubmitting] = useState(false);

  // Use the patientId prop directly
  //const patient_id = patientId
  const [sending, setSending] = useState(false);
  const [show, setShow] = useState(false)
  const [hovered, setHovered] = useState(null)
  const [isEditMode, setIsEditMode] = useState(false)
  const [currentEditId, setCurrentEditId] = useState("")
  const [formData, setFormData] = useState({
    pregnancy_status: "",
    medication: "",
    marriage_info_id: 1,
    delivery_date: "",
    How_was_the_delivery: "",
    gender: "",
    abortion_date: "",
    which_rx_helped: "",
    how_did_miscarriage_happen: "",
    miscarriage_reason: "",
  })
  const [loading, setLoading] = useState(false);

  const marriageHistoryOptions = [
    { value: 1, label: "1st" },
    { value: 2, label: "2nd" },
    { value: 3, label: "3rd" },
    { value: 4, label: "4th" },
    { value: 5, label: "5th" },
  ];

  const medicationOptions = [
    { value: "None", label: "None" },
    { value: "Ayurvedic", label: "Ayurvedic" },
    { value: "Allopathic", label: "Allopathic" },
    { value: "Hormonal", label: "Hormonal" },
    { value: "Other", label: "Other" },
  ];

  const calculateAge = (dateString) => {
    if (!dateString || dateString === "0000-00-00") return 0
    const birthDate = new Date(dateString)
    const today = new Date()
    let age = today.getFullYear() - birthDate.getFullYear()
    const monthDiff = today.getMonth() - birthDate.getMonth()
    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
      age--
    }
    return age
  }

  useEffect(() => {
    console.log("PatientGapld got patient_id:", patient_id);
    if (patient_id) {
      dispatch(getPatientGapldAction(patient_id))
    }
  }, [dispatch, patient_id])

  const getActiveEntriesWithSequentialIds = () => {
    const activeEntries = patientGapldEntries
      .filter((entry) => entry.gapld_status !== "Delete")
      .sort((a, b) => Number.parseInt(a.gapld_id) - Number.parseInt(b.gapld_id))
    return activeEntries.map((entry, index) => ({
      ...entry,
      sequentialId: index + 1,
      displayId: `g${index + 1}`,
    }))
  }

  const activeEntries = getActiveEntriesWithSequentialIds()

  // Fetch patientDetails from Redux only when needed for marriageInfo
  // const prescriptionPatientDetails = useSelector((state) => state.prescriptionState?.patientDetails)

  const getMarriageHistoryOptions = () => {
    if (!prescriptionPatientDetails?.marriageInfo || prescriptionPatientDetails.marriageInfo.length === 0) {
      return []
    }
    return prescriptionPatientDetails.marriageInfo.map((marriage) => ({
      value: marriage.marriage_info_id,
      label: marriage.marriage_history,
    }))
  }

  const getMarriageHistoryText = (marriageInfoId) => {
    if (!prescriptionPatientDetails?.marriageInfo || !marriageInfoId) return "Not specified"
    const marriageInfo = prescriptionPatientDetails.marriageInfo.find(
      (marriage) => marriage.marriage_info_id == marriageInfoId,
    )
    return marriageInfo?.marriage_history || "Not specified"
  }

  const transformDataForDisplay = () => {
    const displayData = {}
    activeEntries.forEach((entry) => {
      const key = entry.displayId
      // const deliveryDate =
      //   entry.delivery_date && entry.delivery_date !== "0000-00-00"
      //     ? `${new Date(entry.delivery_date).toLocaleDateString("en-US")} - ${calculateAge(entry.delivery_date)} years`
      //     : ""
      // const abortionDate =
      //   entry.abortion_date && entry.abortion_date !== "0000-00-00"
      //     ? new Date(entry.abortion_date).toLocaleDateString("en-US", {
      //         month: "short",
      //         year: "numeric",
      //       })
      //     : ""
      const deliveryDate =
        entry.delivery_date && entry.delivery_date !== "0000-00-00"
          ? formatDate(entry.delivery_date, true) // with age
          : "";

      const abortionDate =
        entry.abortion_date && entry.abortion_date !== "0000-00-00"
          ? formatDate(entry.abortion_date) // only date
          : "";
      displayData[key] = [
        entry.pregnancy_status === "Abortion /Miscarriage"
          ? abortionDate || "Not specified"
          : deliveryDate || "Not specified",
        entry.which_rx_helped || "Not specified",
        getMarriageHistoryText(entry.marriage_info_id) || "",
        entry.How_was_the_delivery || (entry.pregnancy_status === "Abortion /Miscarriage" ? "N/A" : "Not specified"),
        entry.gender || (entry.pregnancy_status === "Abortion /Miscarriage" ? "N/A" : "Not specified"),
        entry.pregnancy_status === "Abortion /Miscarriage"
          ? entry.how_did_miscarriage_happen || "Not specified"
          : "N/A",
        entry.pregnancy_status === "Abortion /Miscarriage" ? entry.miscarriage_reason || "Not specified" : "N/A",
        <div key={`${key}-details`} style={{ whiteSpace: "pre-line" }}>
          {entry.pregnancy_status === "Abortion /Miscarriage"
            ? `${key.toUpperCase()}\n${abortionDate || "Not specified"}\nAbortion\n${entry.which_rx_helped || "Not specified"
            }\nMiscarriage:\n${entry.how_did_miscarriage_happen || "Not specified"}`
            : `${key.toUpperCase()}\n${deliveryDate || "Not specified"}\n${entry.which_rx_helped || "Not specified"
            }\n${entry.How_was_the_delivery || "Not specified"}\n${entry.gender || "Not specified"}`}
        </div>,
      ]
    })
    return displayData
  }

  const data = transformDataForDisplay()

  const attributes = [
    "Abortion Month, Year, Date of Birth - Age",
    "Which RX helped to maintain pregnancy?",
    "Marriage History",
    "How was the delivery?",
    "Male/Female",
    "How did the miscarriage happen?",
    "Miscarriage Reason",
    "",
  ]

  const deliveryOptionList = [
    { value: "Delivered", label: "Delivered" },
    { value: "Abortion", label: "Abortion" },
    { value: "Miscarriage", label: "Miscarriage" },
  ];


  const handleInChange = (e) => {
    const { name, value } = e.target
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }))
  }
  const handleSendLink = async () => {
    if (!patient_id) {
      showErrorAlert("Patient ID not found!");
      return;
    }
    try {
      setSending(true); // 🔄 start loading
      await dispatch(sendGenderFormLinkAction(patient_id, "GAPLD"));
      // handleSuccess("Link sent successfully!");
    } catch (err) {
      console.error(err);
      showErrorAlert("Failed to send link");
    } finally {
      setSending(false); // ⏹ stop loading
    }
  };

  const handleinSubmit = async (e) => {
    e.preventDefault()
    if (submitting) return;

    setSubmitting(true);
    const payload = {
      ...formData,
      patient_id: patient_id,
    }

    try {
      if (isEditMode && currentEditId) {
        const entryToUpdate = activeEntries.find((entry) => entry.displayId === currentEditId)
        if (entryToUpdate) {
          payload.gapld_id = entryToUpdate.gapld_id
          await dispatch(updatePatientGapldAction(payload))
        }
      } else {
        await dispatch(createPatientGapldAction(payload))
      }

      // ✅ 
      await dispatch(getPatientGapldAction(patient_id))

      handleCloseModal()
    } catch (err) {
      console.error("GAPLD submit error:", err)
      showErrorAlert("Failed to save GAPLD record")
    }
    finally {
      setSubmitting(false); // ✅ Stop spinner
    }
  }


  const resetForm = () => {
    setFormData({
      pregnancy_status: "",
      marriage_info_id: 1,
      delivery_date: "",
      How_was_the_delivery: "",
      gender: "",
      abortion_date: "",
      which_rx_helped: "",
      how_did_miscarriage_happen: "",
      miscarriage_reason: "",
    })
  }

  const handleCloseModal = () => {
    setShow(false)
    setIsEditMode(false)
    setCurrentEditId("")
    resetForm()
  }

  const handleAddClick = () => {
    setIsEditMode(false)
    setCurrentEditId("")
    resetForm()
    setShow(true)
  }

  const handleEditClick = (displayId) => {
    const entry = activeEntries.find((entry) => entry.displayId === displayId)
    if (entry) {
      setIsEditMode(true)
      setCurrentEditId(displayId)
      setFormData({
        pregnancy_status: entry.pregnancy_status || "",
        marriage_info_id: entry.marriage_info_id || "",
        delivery_date: entry.delivery_date !== "0000-00-00" ? entry.delivery_date : "",
        How_was_the_delivery: entry.How_was_the_delivery || "",
        gender: entry.gender || "",
        abortion_date: entry.abortion_date !== "0000-00-00" ? entry.abortion_date : "",
        which_rx_helped: entry.which_rx_helped || "",
        how_did_miscarriage_happen: entry.how_did_miscarriage_happen || "",
        miscarriage_reason: entry.miscarriage_reason || "",
      })
      setShow(true)
    }
  }

  const handleDeleteClick = (displayId) => {
    const entry = activeEntries.find((entry) => entry.displayId === displayId)
    if (entry) {
      if (window.confirm("Are you sure you want to delete this entry?")) {
        dispatch(deletePatientGapldAction(entry))
      }
    }
  }
  const customStyles = {
    control: (base) => ({
      ...base,
      minHeight: "38px",
      fontSize: "14px",
    }),
    valueContainer: (base) => ({
      ...base,
      padding: "0 8px",
    }),
    input: (base) => ({
      ...base,
      margin: "0px",
      fontSize: "14px",
    }),
    placeholder: (base) => ({
      ...base,
      fontSize: "14px",
    }),
    singleValue: (base) => ({
      ...base,
      fontSize: "14px",
    }),
  };

  if (activeEntries.length === 0) {
    return (
      <div className="row">
        <div className="col-xl-12">
          <div className="card shadow-none">
            <div className="card-body">
              <div className="text-end mb-3 d-flex gap-2 justify-content-end">
                <button className="btn btn-outline-primary btn-smbtn-outline-primary btn-sm" onClick={handleAddClick}>
                  Add
                </button>
                <button
                  className="btn btn-outline-primary btn-sm"
                  disabled={sending} // ✅ disable while loading
                  onClick={handleSendLink}
                >
                  {sending ? "Sending..." : "Send Link"}
                </button>
              </div>
              <div className="text-center py-5">
                <h5 className="text-muted">No GAPLD records found</h5>
                <p className="text-muted">Click "Add" to create a new record</p>
              </div>
            </div>
          </div>
        </div>
        {show && (
          <div
            className="modal"
            style={{
              display: "block",
              position: "fixed",
              zIndex: 1050,
              left: 0,
              top: 0,
              width: "100%",
              height: "100%",
              backgroundColor: "rgba(0, 0, 0, 0.5)",
            }}
            onClick={(e) => {
              if (e.target === e.currentTarget) {
                handleCloseModal()
              }
            }}
          >
            <div className="modal-dialog modal-lg" style={{ margin: "1.75rem auto" }}>
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Add Details</h5>
                  <button
                    type="button"
                    className="btn-close"
                    onClick={handleCloseModal}
                    style={{ background: "none", border: "none", fontSize: "1.5rem" }}
                  >
                    ×
                  </button>
                </div>
                <div className="modal-body">
                  <form onSubmit={handleinSubmit}>
                    <div className="mb-3">
                      <label htmlFor="pregnancy_status" style={{ marginBottom: "0.5rem" }}>
                        Pregnancy Status <span style={{ color: "red" }}>*</span>
                      </label>
                      <Select
                        name="pregnancy_status"
                        options={deliveryOptionList}
                        value={
                          formData.pregnancy_status
                            ? deliveryOptionList.find((opt) => opt.value === formData.pregnancy_status)
                            : null
                        }
                        onChange={(selectedOption) =>
                          setFormData((prev) => ({
                            ...prev,
                            pregnancy_status: selectedOption?.value || "",
                          }))
                        }
                        placeholder="Select Pregnancy Status"
                        required
                      />
                    </div>
                    <div className="mb-3">
                      <label className="form-label fw-bold">
                        Which Medication<span style={{ color: "red" }}>*</span>
                      </label>

                      <Select
                        name="medication"
                        options={medicationOptions}
                        value={
                          formData.medication
                            ? medicationOptions.find((opt) => opt.value === formData.medication)
                            : null
                        }
                        onChange={(selectedOption) =>
                          setFormData((prev) => ({
                            ...prev,
                            medication: selectedOption?.value || "",
                          }))
                        }
                        placeholder="Select Medication"
                        // styles={customStyles}
                        required
                      />
                    </div>

                    {/* <div className="mb-3">
                      <label className="form-label fw-bold">
                        Marriage History<span style={{ color: "red" }}>*</span>
                      </label>
                      <select
                        className="form-select"
                        name="marriage_info_id"
                        value={formData.marriage_info_id}
                        onChange={handleInChange}
                        style={{ height: "50px" }}
                        required
                      >
                        <option value="">Select Marriage History</option>
                        {getMarriageHistoryOptions().map((option) => (
                          <option key={option.value} value={option.value}>
                            {option.label}
                          </option>
                        ))}
                      </select>
                    </div> */}
                    <div className="mb-3">
                      <label className="form-label fw-bold">
                        Marriage History <span style={{ color: "red" }}>*</span>
                      </label>

                      <Select
                        name="marriage_info_id"
                        options={marriageHistoryOptions}
                        value={
                          marriageHistoryOptions.find(
                            (opt) => opt.value === formData.marriage_info_id
                          ) || null
                        }
                        onChange={(selectedOption) =>
                          setFormData((prev) => ({
                            ...prev,
                            marriage_info_id: selectedOption?.value || 1,
                          }))
                        }
                        placeholder="Select Marriage History"
                        isClearable
                        styles={customStyles} // same as your other select dropdown
                      />
                    </div>

                    {formData.pregnancy_status === "Abortion" && (
                      <div>
                        <div className="row">
                          <div className="col-xl-6 mb-3">
                            <label htmlFor="abortion_date">Abortion Date<span style={{ color: "red" }}>*</span></label>
                            <input
                              id="abortion_date"
                              type="month"
                              className="form-control"
                              name="abortion_date"
                              value={formData.abortion_date}
                              onChange={handleInChange}
                              max={new Date().toISOString().slice(0, 7)}
                              required
                            />
                          </div>
                          <div className="col-xl-6 mb-3">
                            <label htmlFor="which_rx_helped">Which RX helped to maintain pregnancy?</label>
                            <input
                              id="which_rx_helped"
                              type="text"
                              className="form-control"
                              name="which_rx_helped"
                              value={formData.which_rx_helped}
                              onChange={handleInChange}
                              placeholder="Enter RX"
                            />
                          </div>
                        </div>
                        {/* <div className="row">
                          <div className="col-xl-6 mb-3">
                            <label htmlFor="how_did_miscarriage_happen">How did the miscarriage happen?</label>
                            <input
                              id="how_did_miscarriage_happen"
                              type="text"
                              className="form-control"
                              name="how_did_miscarriage_happen"
                              value={formData.how_did_miscarriage_happen}
                              onChange={handleInChange}
                              placeholder="Enter details"
                            />
                          </div>
                          <div className="col-xl-6 mb-3">
                            <label htmlFor="miscarriage_reason">Miscarriage Reason</label>
                            <input
                              id="miscarriage_reason"
                              type="text"
                              className="form-control"
                              name="miscarriage_reason"
                              value={formData.miscarriage_reason}
                              onChange={handleInChange}
                              placeholder="Enter reason"
                            />
                          </div>
                        </div> */}
                      </div>
                    )}

                    {formData.pregnancy_status === "Miscarriage" && (
                      <div>
                        <div className="row">
                          <div className="col-xl-6 mb-3">
                            <label htmlFor="abortion_date">Miscarriage Date<span style={{ color: "red" }}>*</span></label>
                            <input
                              id="abortion_date"
                              type="month"
                              className="form-control"
                              name="abortion_date"
                              value={formData.abortion_date}
                              onChange={handleInChange}
                              max={new Date().toISOString().slice(0, 7)}
                              required
                            />
                          </div>
                          <div className="col-xl-6 mb-3">
                            <label htmlFor="which_rx_helped">Which RX helped to maintain pregnancy?</label>
                            <input
                              id="which_rx_helped"
                              type="text"
                              className="form-control"
                              name="which_rx_helped"
                              value={formData.which_rx_helped}
                              onChange={handleInChange}
                              placeholder="Enter RX"
                            />
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-xl-6 mb-3">
                            <label htmlFor="how_did_miscarriage_happen">How did the miscarriage happen?</label>
                            <input
                              id="how_did_miscarriage_happen"
                              type="text"
                              className="form-control"
                              name="how_did_miscarriage_happen"
                              value={formData.how_did_miscarriage_happen}
                              onChange={handleInChange}
                              placeholder="Enter details"
                            />
                          </div>
                          <div className="col-xl-6 mb-3">
                            <label htmlFor="miscarriage_reason">Miscarriage Reason</label>
                            <input
                              id="miscarriage_reason"
                              type="text"
                              className="form-control"
                              name="miscarriage_reason"
                              value={formData.miscarriage_reason}
                              onChange={handleInChange}
                              placeholder="Enter reason"
                            />
                          </div>
                        </div>
                      </div>
                    )}
                    {formData.pregnancy_status === "Delivered" && (
                      <div>
                        <div className="row">
                          <div className="col-6 mb-3">
                            <label htmlFor="delivery_date">Delivery Date<span style={{ color: "red" }}>*</span></label>
                            <input
                              id="delivery_date"
                              type="month"
                              className="form-control"
                              name="delivery_date"
                              value={formData.delivery_date}
                              onChange={handleInChange}
                              max={new Date().toISOString().slice(0, 7)}
                              required
                            />
                          </div>
                          <div className="col-xl-6 mb-3">
                            <label htmlFor="which_rx_helped">Which RX helped to maintain pregnancy?</label>
                            <input
                              id="which_rx_helped"
                              type="text"
                              className="form-control"
                              name="which_rx_helped"
                              value={formData.which_rx_helped}
                              onChange={handleInChange}
                              placeholder="Enter RX"
                            />
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-xl-6 mb-3">
                            <label htmlFor="How_was_the_delivery">How was the delivery?<span style={{ color: "red" }}>*</span></label>
                            <input
                              id="How_was_the_delivery"
                              type="text"
                              className="form-control"
                              name="How_was_the_delivery"
                              value={formData.How_was_the_delivery}
                              onChange={handleInChange}
                              placeholder="Enter delivery details"
                            />
                          </div>
                          <div className="col-xl-6 mb-3">
                            <label htmlFor="gender">Gender</label>
                            <select
                              id="gender"
                              className="form-control"
                              name="gender"
                              value={formData.gender}
                              onChange={handleInChange}
                            >
                              <option value="">Select Gender</option>
                              <option value="Male">Male</option>
                              <option value="Female">Female</option>
                              <option value="Transgender">Transgender</option>
                            </select>
                          </div>
                        </div>
                      </div>
                    )}
                    <button type="submit" className="btn btn-primary mt-3">
                      Save Changes
                    </button>
                  </form>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    )
  }

  return (
    <div className="row">
      <div className="col-xl-12">
        <div className="card shadow-none">
          <div className="card-body">
            <div className="text-end mb-3 d-flex gap-2 justify-content-end">
              <button className="btn btn-outline-primary btn-sm" onClick={handleAddClick}>
                Add
              </button>
              <button
                className="btn btn-outline-primary btn-sm"
                disabled={sending} // ✅ disable while loading
                onClick={handleSendLink}
              >
                {sending ? "Sending..." : "Send Link"}
              </button>
            </div>
            <div className="table-responsive">
              <div id="patient" className="dataTables_wrapper no-footer">
                <table
                  className="table header-border"
                  style={{
                    width: "100%",
                    borderCollapse: "collapse",
                    border: "2px solid #ddd",
                    margin: "0 auto",
                  }}
                >
                  <thead style={{ color: "black", fontWeight: "bold" }}>
                    <tr className="table-info">
                      <th scope="col"></th>
                      {activeEntries.map((entry) => (
                        <th
                          key={entry.displayId}
                          scope="col"
                          style={{
                            color: "black",
                            fontWeight: "bold",
                            padding: "10px",
                            backgroundColor: entry.sequentialId <= 2 ? "yellow" : "lightgreen",
                            textAlign: "center",
                            position: "relative",
                          }}
                          onMouseEnter={() => setHovered(entry.displayId)}
                          onMouseLeave={() => setHovered(null)}
                        >
                          {entry.displayId}
                          <div
                            className="tooltip"
                            style={{
                              position: "absolute",
                              backgroundColor: "black",
                              color: "white",
                              padding: "5px",
                              borderRadius: "4px",
                              visibility: hovered === entry.displayId ? "visible" : "hidden",
                              opacity: hovered === entry.displayId ? 1 : 0,
                              transition: "opacity 0.3s",
                              zIndex: 10,
                              top: "50px",
                              left: "50%",
                              transform: "translateX(-50%)",
                            }}
                          >
                            {getMarriageHistoryText(entry.marriage_info_id) || "Not specified"}
                          </div>
                        </th>
                      ))}
                    </tr>
                    <tr className="table-warning">
                      <th
                        scope="col"
                        style={{
                          color: "black",
                          fontWeight: "bold",
                          padding: "10px",
                          textAlign: "center",
                          verticalAlign: "middle",
                        }}
                      >
                        G= A+P
                      </th>
                      {activeEntries.map((entry) => (
                        <th
                          key={entry.displayId}
                          scope="col"
                          style={{
                            color: "black",
                            fontWeight: "bold",
                            padding: "10px",
                            textAlign: "center",
                            verticalAlign: "middle",
                          }}
                        >
                          {entry.sequentialId <= 2 ? "A" + entry.sequentialId : "M" + (entry.sequentialId - 2)}
                          <div className="mt-2 d-flex justify-content-center gap-3">
                            <i
                              className="fa fa-pencil-alt text-success"
                              style={{ cursor: "pointer" }}
                              onClick={() => handleEditClick(entry.displayId)}
                              title="Edit"
                            />
                            <i
                              className="fa fa-trash text-danger"
                              style={{ cursor: "pointer" }}
                              onClick={() => handleDeleteClick(entry.displayId)}
                              title="Delete"
                            />
                          </div>
                        </th>
                      ))}
                    </tr>
                  </thead>
                  <tbody style={{ backgroundColor: "white" }}>
                    {attributes.map((attribute, index) => (
                      <tr key={index}>
                        <th
                          scope="row"
                          style={{
                            color: "black",
                            fontWeight: "normal",
                            padding: "10px",
                          }}
                        >
                          {attribute}
                        </th>
                        {activeEntries.map((entry) => {
                          const cellValue = data[entry.displayId]?.[index] || "N/A"

                          return (
                            <td
                              key={entry.displayId}
                              style={{
                                padding: "10px",
                                backgroundColor: "white",
                                textAlign: "left",
                              }}
                            >
                              {cellValue}
                            </td>
                          )
                        })}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
            {show && (
              <div
                className="modal"
                style={{
                  display: "block",
                  position: "fixed",
                  zIndex: 1050,
                  left: 0,
                  top: 0,
                  width: "100%",
                  height: "100%",
                  backgroundColor: "rgba(0, 0, 0, 0.5)",
                }}
                onClick={(e) => {
                  if (e.target === e.currentTarget) {
                    handleCloseModal()
                  }
                }}
              >
                <div className="modal-dialog modal-lg" style={{ margin: "1.75rem auto" }}>
                  <div className="modal-content">
                    <div className="modal-header">
                      <h5 className="modal-title">
                        {isEditMode ? `Edit Details (${currentEditId.toUpperCase()})` : "Add Details"}
                      </h5>
                      <button
                        type="button"
                        className="btn-close"
                        onClick={handleCloseModal}
                        style={{ background: "none", border: "none", fontSize: "1.5rem" }}
                      >
                        ×
                      </button>
                    </div>
                    <div className="modal-body">
                      <form onSubmit={handleinSubmit}>
                        <div className="mb-3">
                          <label htmlFor="pregnancy_status" style={{ marginBottom: "0.5rem" }}>
                            Pregnancy Status<span style={{ color: "red" }}>*</span>
                          </label>
                          <Select
                            name="pregnancy_status"
                            options={deliveryOptionList}
                            value={
                              formData.pregnancy_status
                                ? deliveryOptionList.find((opt) => opt.value === formData.pregnancy_status)
                                : null
                            }
                            onChange={(selectedOption) =>
                              setFormData((prev) => ({
                                ...prev,
                                pregnancy_status: selectedOption?.value || "",
                              }))
                            }
                            placeholder="Select Pregnancy Status"
                            required
                          />
                        </div>
                        <div className="mb-3">
                          <label className="form-label fw-bold">
                            Which Medication<span style={{ color: "red" }}>*</span>
                          </label>

                          <Select
                            name="medication"
                            options={medicationOptions}
                            value={
                              formData.medication
                                ? medicationOptions.find((opt) => opt.value === formData.medication)
                                : null
                            }
                            onChange={(selectedOption) =>
                              setFormData((prev) => ({
                                ...prev,
                                medication: selectedOption?.value || "",
                              }))
                            }
                            placeholder="Select Medication"
                            // styles={customStyles}
                            required
                          />
                        </div>

                        {/* <div className="mb-3">
                          <label className="form-label fw-bold">
                            Marriage History<span style={{ color: "red" }}>*</span>
                          </label>
                          <select
                            className="form-select"
                            name="marriage_info_id"
                            value={formData.marriage_info_id}
                            onChange={handleInChange}
                            style={{ height: "50px" }}
                            required
                          >
                            <option value="">Select Marriage History</option>
                            {getMarriageHistoryOptions().map((option) => (
                              <option key={option.value} value={option.value}>
                                {option.label}
                              </option>
                            ))}
                          </select>
                        </div> */}
                        <div className="mb-3">
                          <label className="form-label fw-bold">
                            Marriage History <span style={{ color: "red" }}>*</span>
                          </label>

                          <Select
                            name="marriage_info_id"
                            options={marriageHistoryOptions}
                            value={
                              marriageHistoryOptions.find(
                                (opt) => opt.value === formData.marriage_info_id
                              ) || null
                            }
                            onChange={(selectedOption) =>
                              setFormData((prev) => ({
                                ...prev,
                                marriage_info_id: selectedOption?.value || 1,
                              }))
                            }
                            placeholder="Select Marriage History"
                            isClearable
                            styles={customStyles} // same as your other select dropdown
                          />
                        </div>
                        {formData.pregnancy_status === "Abortion" && (
                          <div>
                            <div className="row">
                              <div className="col-xl-6 mb-3">
                                <label htmlFor="abortion_date">Abortion Date<span style={{ color: "red" }}>*</span></label>
                                <input
                                  id="abortion_date"
                                  type="month"
                                  className="form-control"
                                  name="abortion_date"
                                  value={formData.abortion_date}
                                  onChange={handleInChange}
                                  max={new Date().toISOString().slice(0, 7)}
                                  required
                                />
                              </div>
                              <div className="col-xl-6 mb-3">
                                <label htmlFor="which_rx_helped">Which RX helped to maintain pregnancy?</label>
                                <input
                                  id="which_rx_helped"
                                  type="text"
                                  className="form-control"
                                  name="which_rx_helped"
                                  value={formData.which_rx_helped}
                                  onChange={handleInChange}
                                  placeholder="Enter RX"
                                />
                              </div>
                            </div>
                            {/* <div className="row">
                              <div className="col-xl-6 mb-3">
                                <label htmlFor="how_did_miscarriage_happen">How did the miscarriage happen?</label>
                                <input
                                  id="how_did_miscarriage_happen"
                                  type="text"
                                  className="form-control"
                                  name="how_did_miscarriage_happen"
                                  value={formData.how_did_miscarriage_happen}
                                  onChange={handleInChange}
                                  placeholder="Enter details"
                                />
                              </div>
                              <div className="col-xl-6 mb-3">
                                <label htmlFor="miscarriage_reason">Miscarriage Reason</label>
                                <input
                                  id="miscarriage_reason"
                                  type="text"
                                  className="form-control"
                                  name="miscarriage_reason"
                                  value={formData.miscarriage_reason}
                                  onChange={handleInChange}
                                  placeholder="Enter reason"
                                />
                              </div>
                            </div> */}
                          </div>
                        )}

                        {formData.pregnancy_status === "Miscarriage" && (
                          <div>
                            <div className="row">
                              <div className="col-xl-6 mb-3">
                                <label htmlFor="abortion_date">Miscarriage Date<span style={{ color: "red" }}>*</span></label>
                                <input
                                  id="abortion_date"
                                  type="month"
                                  className="form-control"
                                  name="abortion_date"
                                  value={formData.abortion_date}
                                  onChange={handleInChange}
                                  max={new Date().toISOString().slice(0, 7)}
                                  required
                                />
                              </div>
                              <div className="col-xl-6 mb-3">
                                <label htmlFor="which_rx_helped">Which RX helped to maintain pregnancy?</label>
                                <input
                                  id="which_rx_helped"
                                  type="text"
                                  className="form-control"
                                  name="which_rx_helped"
                                  value={formData.which_rx_helped}
                                  onChange={handleInChange}
                                  placeholder="Enter RX"
                                />
                              </div>
                            </div>
                            <div className="row">
                              <div className="col-xl-6 mb-3">
                                <label htmlFor="how_did_miscarriage_happen">How did the miscarriage happen?</label>
                                <input
                                  id="how_did_miscarriage_happen"
                                  type="text"
                                  className="form-control"
                                  name="how_did_miscarriage_happen"
                                  value={formData.how_did_miscarriage_happen}
                                  onChange={handleInChange}
                                  placeholder="Enter details"
                                />
                              </div>
                              <div className="col-xl-6 mb-3">
                                <label htmlFor="miscarriage_reason">Miscarriage Reason</label>
                                <input
                                  id="miscarriage_reason"
                                  type="text"
                                  className="form-control"
                                  name="miscarriage_reason"
                                  value={formData.miscarriage_reason}
                                  onChange={handleInChange}
                                  placeholder="Enter reason"
                                />
                              </div>
                            </div>
                          </div>
                        )}
                        {formData.pregnancy_status === "Delivered" && (
                          <div>
                            <div className="row">
                              <div className="col-6 mb-3">
                                <label htmlFor="delivery_date">Delivery Date<span style={{ color: "red" }}>*</span></label>
                                <input
                                  id="delivery_date"
                                  type="month"
                                  className="form-control"
                                  name="delivery_date"
                                  value={formData.delivery_date}
                                  onChange={handleInChange}
                                  max={new Date().toISOString().slice(0, 7)}
                                  required
                                />
                              </div>
                              <div className="col-xl-6 mb-3">
                                <label htmlFor="which_rx_helped">Which RX helped to maintain pregnancy?</label>
                                <input
                                  id="which_rx_helped"
                                  type="text"
                                  className="form-control"
                                  name="which_rx_helped"
                                  value={formData.which_rx_helped}
                                  onChange={handleInChange}
                                  placeholder="Enter RX"
                                />
                              </div>
                            </div>
                            <div className="row">
                              <div className="col-xl-6 mb-3">
                                <label htmlFor="How_was_the_delivery">How was the delivery?</label>
                                <input
                                  id="How_was_the_delivery"
                                  type="text"
                                  className="form-control"
                                  name="How_was_the_delivery"
                                  value={formData.How_was_the_delivery}
                                  onChange={handleInChange}
                                  placeholder="Enter delivery details"
                                />
                              </div>
                              <div className="col-xl-6 mb-3">
                                <label htmlFor="gender">Gender</label>
                                <select
                                  id="gender"
                                  className="form-control"
                                  name="gender"
                                  value={formData.gender}
                                  onChange={handleInChange}
                                >
                                  <option value="">Select Gender</option>
                                  <option value="Male">Male</option>
                                  <option value="Female">Female</option>
                                  <option value="Transgender">Transgender</option>
                                </select>
                              </div>
                            </div>
                          </div>
                        )}
                        {/* <button type="submit" className="btn btn-primary mt-3">
                          {isEditMode ? "Update" : "Save Changes"}
                        </button> */}
                        <Button
                          type="submit"
                          variant="primary"
                          className="mt-3"
                          disabled={submitting}
                        >
                          {submitting ? (
                            <>
                              <Spinner animation="border" size="sm" className="me-2" />
                              {isEditMode ? "Updating..." : "Saving..."}
                            </>
                          ) : (
                            isEditMode ? "Update" : "Save Changes"
                          )}
                        </Button>

                      </form>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default PatientGapld;
